export enum ActivityProjection {
    users = 'users',
    action = 'action',
    note = 'note',
    pmp = 'pmp',
    doc = 'doc',
    participants = 'participants',
    entity = 'entity',
    general = 'general',
    dataTable = 'dataTable',
    activityData = 'activityData',
    schedule = 'schedule',
    pmpCaseNumber = 'pmpCaseNumber',
    payments = 'payments',
    survey = 'survey',
}
